<template>
  <div class="packing-list">
    <home-nav-bar title="半成品">
      <div slot="right" class="nav-bar-right">
        <div class="title" style="color:#20caa0;" @click="handleOperation(undefined)">
          +增加半成品
        </div>
      </div>
    </home-nav-bar>
    <wh-mobile-list ref="listTable" class="main" data-src="/api/getParPreparedProductsList">
      <template v-slot="{list}">
        <div
          v-for="i in list"
          :key="i.id"
          class="list-item"
        >
          <div class="list-card">
            <div>
              <div class="wh-flex-between">
                <span style="font-size: 14px">{{ i.name }}</span><span class="num">{{ i.quantity + i.unit }}</span>
              </div>
              <div class="wh-flex-between" style="color: #BBBBBB;font-size: 14px">
                <div>
                  <div><span>原料：{{ i.rawMaterials }}</span></div>
                  <div>
                    <span>工艺：{{ i.processMng }}</span>
                  </div>
                </div>
                <van-icon v-if="i.isEditable" name="arrow" @click.stop="handleOperation(i.id)" />
              </div>
            </div>
            <div class="wh-flex-center view-stock" @click.stop="handleView(i.id)">
              查看库存明细
            </div>
          </div>
        </div>
      </template>
    </wh-mobile-list>
    <product-stock-list
      :list-id="popup.stock.id"
      :visible.sync="popup.stock.visit"
      @close="$refs.listTable.onRefresh()"
    />
    <popup-product-operation
      :product-id="popup.product.id"
      :visible.sync="popup.product.visit"
      @close="$refs.listTable.onRefresh()"
    />
  </div>
</template>

<script>
import HomeNavBar from '@/views/layout/components/HomeNavBar'
import WhMobileList from '@/components/public/WhMobileList/WhMobileList'
import ProductStockList from '@/views/partiallyPreparedProducts/product-stock-list'
import PopupProductOperation from '@/views/partiallyPreparedProducts/popup-product-operation'
import api from '@/api'

export default {
  name: 'PartiallyPreparedProducts',
  components: { HomeNavBar, WhMobileList, ProductStockList, PopupProductOperation },
  data() {
    return {
      popup: {
        stock: { id: undefined, visit: false },
        product: { id: undefined, visit: false }
      }
    }
  },
  methods: {
    handleOperation(id) {
      this.popup.product.id = id
      this.popup.product.visit = true
    },
    handleView(id) {
      this.popup.stock.id = id
      this.popup.stock.visit = true
    },
    handleDel(id) {
      this.$dialog.confirm({
        title: '是否删除?'
      })
        .then(() => {
          api.deleteParPreparedProducts({ ids: [id] }).then(() => {
            this.$refs.listTable.onRefresh()
          })
        })
        .catch(() => {
          // on cancel
        })
    }
  }
}
</script>

<style lang="less" scoped>
.packing-list {
  height: 100%;
  display: flex;
  flex-direction: column;
  .nav-bar-right {
    .title {
      color: #20CAA0;
    }
  }
}
.list-card {
  background: #FFFFFF;
  padding: 12px;
  border-radius: 8px;
  margin: 12px 0 0;
  > div:first-child .num {
    display: inline-block;
    width: 46px;
    height: 16px;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
    color: #fff;
    background-color: #20CAA0;
    border-radius: 2px;
  }
}
.view-stock {
  margin-top: 10px;
  font-size: 14px;
}
</style>
